import { makeCall, Methods } from "../../utils/makeCall";
import { InquireShahkarErrors } from "./shahkar.error";

export type InquireShahkarRequest = { phone: string; national_id: string };
export type InquireShahkarResponse = { authorized: boolean };

export const inquireShahkar = makeCall<
  InquireShahkarRequest,
  InquireShahkarResponse,
  InquireShahkarErrors
>(Methods.InquireShahkar);
